import { Component, Input } from '@angular/core';
import { CaptureQueueResult } from '../../../core/models/capture-lists/capture-queue-result.model';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { HighValueIndicatorComponent } from '../../../shared/components/high-value-indicator/high-value-indicator.component';
import { CaptureStatusPipe } from 'app/shared/pipes/capture-status.pipe';
import { CaptureStatusReasonPipe } from '../../../shared/pipes/capture-status-reason.pipe';

@Component({
    selector: 'app-capture-search-results',
    templateUrl: './capture-search-results.component.html',
    styleUrls: ['./capture-search-results.component.scss'],
    imports: [RouterLink,
              UserPresenceComponent,
              PrescriberNameComponent,
              HighValueIndicatorComponent,
              DatePipe,
              CaptureStatusPipe,
              CaptureStatusReasonPipe]
})
export class CaptureSearchResultsComponent {
  @Input() captureQueueResults: CaptureQueueResult[] = [];

  constructor() {}
}
